const getters = {
  // sidebar: state => state.app.sidebar,
  sidebar: state => state.app.sidebar,
  headNavbar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  zsname: state => state.user.zsname,
  menus: state => state.user.menus,
  btnroles: state => state.user.btnroles,
  department: state => state.user.department,
  keepalivemenu: state => state.user.keepalivemenu,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs
};
export default getters;
